function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  white-space: nowrap;\n  text-align: left;\n  border-bottom-style: solid;\n  border-bottom-width: ", ";\n  border-bottom-color: ", ";\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  padding: 1.3125rem 0 0.3125rem;\n\n  ", " {\n    padding: 1.3125rem 0.75rem 0.3125rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  height: ", ";\n\n  ", " {\n    padding: 0 0.75rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled, { css, from } from "../../../../../theme";
var defaultCellStyle = css(_templateObject(), function (props) {
  return props.theme.variables.fonts.size.smaller0;
}, function (props) {
  return props.theme.variables.list.row.height.bigger;
}, from('md'));
var groupHeaderCellStyle = css(_templateObject2(), function (props) {
  return props.theme.variables.fonts.size.smaller1;
}, from('md'));
export var CellWrapper = styled.td(_templateObject3(), function (props) {
  return props.theme.variables.borders.width.base;
}, function (props) {
  return props.theme.variables.colors.platinum;
}, function (props) {
  return props.groupHeader ? groupHeaderCellStyle : defaultCellStyle;
});